export const Props = () => ({
  //Массив с объектами миниатюр, гифок и видео
  data: {
    type: Array,
  },
});